//Object that contains urls to the different webapis of the Communitraders mt4 and mt5 services

const urls = {
    mt4Test: 'http://3.8.90.169:5001',
    mt4Demo: 'https://mamviewer-mt4-demo.tradeviewforex.com',
    mt4Live1: 'https://mamviewer-mt4-live-1.tradeviewforex.com',
    mt4Live2: 'https://mamviewer-mt4-live-2.tradeviewforex.com',
    mt5Test: 'http://3.8.90.169:5005',
    mt5Demo: 'https://mamviewer-mt5-demo.tradeviewforex.com',
    mt5Live: 'https://mamviewer-mt5-live.tradeviewforex.com',
  };
  
  export { urls };